import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";
import type { AsyncButtonProps } from "src/components/common/buttons/AsyncButton.tsx";

export interface AsyncMenuButtonProps extends Omit<AsyncButtonProps, "variant"> {}

export const AsyncMenuButton = (props: AsyncMenuButtonProps) => {
	return <AsyncButton variant={"menu"} {...props} />;
};
